import HotelRoomMappingType from '@app/model/market_state/HotelRoomMappingType';
import React, { ChangeEvent } from 'react';
import Utilities from '@util/Utilities';
import { ErrorMessage } from '@hookform/error-message';
import _isEmpty from 'lodash/isEmpty';
import CompanyHotel from '@app/model/company_hotel/CompanyHotel';

const AlertFilterRoomTypesField: React.FunctionComponent<{
	form: any,
	companyHotel: CompanyHotel
}> = ({ form, companyHotel }) => {


	const roomTypes = companyHotel.roomMappingTypeConfiguration!.configs.filter(rt => rt.isEnabled && rt.type !== HotelRoomMappingType.NONE);

	const roomTypesWatch: HotelRoomMappingType[] = form.watch('filter.roomTypes');
	const onChange = (e: ChangeEvent<HTMLInputElement>) => {
		if (!e.target.checked && !_isEmpty(roomTypesWatch)) {
			const idx = roomTypesWatch.findIndex(rt => rt === e.target.value);
			form.setValue('filter.roomTypes', roomTypesWatch.splice(0, idx));
		} else if (!_isEmpty(roomTypesWatch)) {
			const latestIndex = roomTypes.findIndex(rt => rt.type === roomTypesWatch[roomTypesWatch.length - 1]);
			const newIndex = roomTypes.findIndex(rt => rt.type === e.target.value);
			if (newIndex === latestIndex + 1) {
				// @ts-ignore
				roomTypesWatch.push(e.target.value);
				form.setValue('filter.roomTypes', roomTypesWatch);
			} else if (newIndex < latestIndex) {
				form.setValue('filter.roomTypes', roomTypesWatch.splice(0, newIndex));
			}
		} else {
			// @ts-ignore
			roomTypesWatch.push(e.target.value);
			form.setValue('filter.roomTypes', roomTypesWatch);
		}
	};

	const contains = (type: HotelRoomMappingType) => {
		return !_isEmpty(roomTypesWatch) && roomTypesWatch.includes(type);
	};

	return <>

		<p className="text-sm font-semibold leading-6 text-gray-900 mb-2">Room Types</p>
		<div className="space-y-4 sm:flex sm:items-center sm:space-x-10 sm:space-y-0">
			{roomTypes.map(rt => <div key={rt.type}
																className="flex items-center">
				<div className="flex items-center">
					<input
						id={`input_${rt.type}`}
						type="checkbox"
						value={rt.type}
						onChange={onChange}
						checked={contains(rt.type)}
						className="input-checkbox"
					/>
					<label htmlFor={`input_${rt.type}`} className="ml-2 label">
						{Utilities.snakeCaseToWords(rt.name)}
					</label>
				</div>
			</div>)}

		</div>
		<ErrorMessage
			errors={form.formState.errors}
			name="filter.roomTypes"
			render={({ message }) => <p className="help help-error">{message}</p>}
		/>
	</>;

};

export default AlertFilterRoomTypesField;